import { t } from "../helpers/userHelper";
import { dictionary } from "../untils/dictionary";

export const MEMBER_ROLE = {
  admin: "admin",
  editing: "editing",
  readOnly: "readOnly",
};

export const memeberRoleScope = [
  {
    value: MEMBER_ROLE.admin,
    label: t(dictionary.admin),
  },
  {
    value: MEMBER_ROLE.editing,
    label: t(dictionary.editing),
  },
  {
    value: MEMBER_ROLE.readOnly,
    label: t(dictionary.readOnly),
  },
];

export const roleScope = [
  { value: t(dictionary.admin), key: MEMBER_ROLE.admin },
  { value: t(dictionary.editing), key: MEMBER_ROLE.editing },
  { value: t(dictionary.readOnly), key: MEMBER_ROLE.readOnly },
];
